import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { formatUsdc, formatBps, parseUsdc, bnToNumber } from '../../utils/format';
import { PACKAGE_NAMES, NUM_PACKAGES } from '../../utils/constants';

export const PackageManager = () => {
  const { viewsR, adminW } = useContracts();
  const notify = useNotify();

  const [pkgs, setPkgs] = useState(null);
  const [selected, setSelected] = useState(0);
  const [price, setPrice] = useState('');
  const [roi, setRoi] = useState('');
  const [periods, setPeriods] = useState('');
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!viewsR) return;
      try {
        const p = await viewsR.getAllPackages();
        if (cancelled) return;
        setPkgs(p);
      } catch (e) {}
    };
    load();
    return () => { cancelled = true; };
  }, [viewsR, reload]);

  const update = async () => {
    if (!adminW) return;
    setBusy(true);
    try {
      const tx = await adminW.updatePackage(selected, parseUsdc(price), roi, periods);
      notify.info('Updating package...');
      await tx.wait();
      notify.success('Package updated');
      setReload((r) => r + 1);
      setPrice(''); setRoi(''); setPeriods('');
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="card mb-24">
        <div className="section-title">All Packages</div>
        {!pkgs ? <div>Loading...</div> : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th><th>Name</th><th>Price</th><th>Daily ROI</th><th>Duration</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: NUM_PACKAGES }).map((_, i) => (
                  <tr key={i}>
                    <td>{i}</td>
                    <td>{PACKAGE_NAMES[i]}</td>
                    <td>${formatUsdc(pkgs.prices[i])}</td>
                    <td>{formatBps(pkgs.rois[i])}</td>
                    <td>{bnToNumber(pkgs.periods[i])} days</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="card">
        <div className="section-title">Update Package</div>
        <div className="admin-form-grid">
          <div className="input-group">
            <label className="input-label">Package ID</label>
            <select className="select" value={selected} onChange={(e) => setSelected(Number(e.target.value))}>
              {Array.from({ length: NUM_PACKAGES }).map((_, i) => (
                <option key={i} value={i}>{i} — {PACKAGE_NAMES[i]}</option>
              ))}
            </select>
          </div>
          <div className="input-group">
            <label className="input-label">Price (USDC)</label>
            <input className="input" type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Daily ROI (bps, 25 = 0.25%)</label>
            <input className="input" type="number" value={roi} onChange={(e) => setRoi(e.target.value)} />
          </div>
          <div className="input-group">
            <label className="input-label">Duration (days)</label>
            <input className="input" type="number" value={periods} onChange={(e) => setPeriods(e.target.value)} />
          </div>
        </div>
        <button className="btn btn-primary" onClick={update} disabled={busy || !price || !roi || !periods}>
          {busy && <ButtonSpinner />}Update Package
        </button>
      </div>
    </div>
  );
};
